import { deleteLifeArea as _deleteLifeArea } from '@griply/services';
import { deleteDoc, doc, getFirestore } from 'firebase/firestore';
import {
  FirestoreWriteOp,
  logFirestoreWriteError,
} from 'shared/services/error-tracking';
import { ID } from 'shared/types/id';

export const deleteLifeArea = async (id: ID): Promise<void> =>
  _deleteLifeArea({
    lifeAreaId: id,
    db: getFirestore(),
    doc,
    deleteDoc,
    onWriteError: (error) =>
      logFirestoreWriteError({
        op: FirestoreWriteOp.DeleteLifeArea,
        error,
        docPath: `life-areas/${id}`,
      }),
  });
